'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _requestMethod = require('../configs/requestMethod');

var requestMethodConstant = _interopRequireWildcard(_requestMethod);

var _requestPath = require('./requestPath');

var _requestPath2 = _interopRequireDefault(_requestPath);

var _errors = require('../errors');

var _sleep = require('./sleep');

var _sleep2 = _interopRequireDefault(_sleep);

var _environment = require('./environment');

var _environment2 = _interopRequireDefault(_environment);

var _envs = require('../configs/envs');

var environmentType = _interopRequireWildcard(_envs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * @since 2016-06-05 09:45
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * @author vivaxy
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

var MOCK_DELAY = 1000;
var SUCCESS_CODE_LOWER_BOUND = 200;
var SUCCESS_CODE_HIGHER_BOUND = 300;
var UNAUTHORIZED_CODE = 401;
var FORBIDDEN_CODE = 403;
var SUCCESS_CODE = 200;

var basicFetchOptions = {
    credentials: 'include',
    /**
     * @see https://wiki.sankuai.com/pages/viewpage.action?pageId=576570639#UPM对接-ajax请求
     */
    headers: {
        'x-requested-with': 'XMLHttpRequest'
    }
};

var sendRequest = function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(config) {
        var response, _config$method, method, data, requestPath, _url$parse, search, urlParsed;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        response = null;
                        _config$method = config.method, method = _config$method === undefined ? requestMethodConstant.GET : _config$method, data = config.data, requestPath = config.url;


                        requestPath = (0, _requestPath2.default)(requestPath);
                        method = method.toUpperCase();

                        if (_environment2.default === environmentType.LOCAL || _environment2.default === environmentType.DEVELOPMENT) {
                            method = requestMethodConstant.GET;
                        }

                        _context.t0 = method;
                        _context.next = _context.t0 === requestMethodConstant.GET ? 8 : _context.t0 === requestMethodConstant.POST ? 14 : 18;
                        break;

                    case 8:
                        _url$parse = _url2.default.parse(requestPath, true), search = _url$parse.search, urlParsed = _objectWithoutProperties(_url$parse, ['search']);

                        requestPath = _url2.default.format(_extends({}, urlParsed, {
                            query: _extends({}, urlParsed.query, data)
                        }));
                        _context.next = 12;
                        return (0, _isomorphicFetch2.default)(requestPath, _extends({}, basicFetchOptions));

                    case 12:
                        response = _context.sent;
                        return _context.abrupt('break', 19);

                    case 14:
                        _context.next = 16;
                        return (0, _isomorphicFetch2.default)(requestPath, _extends({}, basicFetchOptions, {
                            method: method,
                            body: JSON.stringify(data),
                            headers: _extends({}, basicFetchOptions.headers, {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            })
                        }));

                    case 16:
                        response = _context.sent;
                        return _context.abrupt('break', 19);

                    case 18:
                        return _context.abrupt('break', 19);

                    case 19:
                        if (!(_environment2.default === environmentType.DEVELOPMENT)) {
                            _context.next = 22;
                            break;
                        }

                        _context.next = 22;
                        return (0, _sleep2.default)(MOCK_DELAY);

                    case 22:
                        return _context.abrupt('return', response);

                    case 23:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function sendRequest(_x) {
        return _ref.apply(this, arguments);
    };
}();

var timeoutPromise = function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(timeout) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return (0, _sleep2.default)(timeout);

                    case 2:
                        throw new _errors.TimeoutError(timeout);

                    case 3:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function timeoutPromise(_x2) {
        return _ref2.apply(this, arguments);
    };
}();

exports.default = function () {
    var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(config) {
        var _config$timeout, timeout, fetchConfig, response, resp;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _config$timeout = config.timeout, timeout = _config$timeout === undefined ? 60000 : _config$timeout, fetchConfig = _objectWithoutProperties(config, ['timeout']);
                        _context3.next = 3;
                        return Promise.race([timeoutPromise(timeout), sendRequest(fetchConfig)]);

                    case 3:
                        response = _context3.sent;

                        if (!(response.status < SUCCESS_CODE_LOWER_BOUND || response.status >= SUCCESS_CODE_HIGHER_BOUND)) {
                            _context3.next = 16;
                            break;
                        }

                        _context3.t0 = response.status;
                        _context3.next = _context3.t0 === UNAUTHORIZED_CODE ? 8 : _context3.t0 === FORBIDDEN_CODE ? 10 : 12;
                        break;

                    case 8:
                        throw new _errors.AuthorizationError();

                    case 10:
                        throw new _errors.ForbiddenError();

                    case 12:
                        throw new _errors.FetchError(response);

                    case 14:
                        _context3.next = 27;
                        break;

                    case 16:
                        _context3.next = 18;
                        return response.json();

                    case 18:
                        resp = _context3.sent;

                        if (!(resp.status === FORBIDDEN_CODE)) {
                            _context3.next = 21;
                            break;
                        }

                        throw new _errors.ForbiddenError();

                    case 21:
                        _context3.t1 = resp.code;
                        _context3.next = _context3.t1 === 0 ? 24 : _context3.t1 === SUCCESS_CODE ? 24 : _context3.t1 === 400 ? 24 : 26;
                        break;

                    case 24:
                        return _context3.abrupt('return', resp.data);

                    case 26:
                        throw new _errors.ServerError(resp);

                    case 27:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, undefined);
    }));

    return function (_x3) {
        return _ref3.apply(this, arguments);
    };
}();


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/lib/fetch.js
// module id = 229
// module chunks = 0